"use client";

import React from "react";
import { StyledPlatofrmHero } from "./howToInstallHero.styles";
import { IPlatform, IPlugin } from "../../types";
import { WidgetNavbar } from "../widgetNavbar/widgetNavbar.comp";
import { CustomLink } from "../link/link.comp";
import { Header } from "../header/header.comp";
import { createMobileAwareClickHandler } from "../../helpers/mobile-redirect";
import { WidgetVideoGuideSSR } from "../widgetVideoGuide/widgetVideoGuide-ssr.comp";
import { SocialProof } from "../socialProof/socialProof.comp";
import Image from "next/image";
import { CommonNinjaWidgetRenderer } from "../CommonNinjaWidgetRenderer/commonNinjaWidgetRenderer.comp";

interface IHowToInstallHeroProps {
  platform?: IPlatform;
  app: IPlugin;
  videoUrl?: string;
  showTemplatesTab?: boolean;
}

export const HowToInstallHero = ({
  platform,
  app,
  videoUrl,
  showTemplatesTab,
}: IHowToInstallHeroProps) => {
  const title = platform
    ? `How to add ${app.name} to a ${platform.title} ${platform.siteSynonym}`
    : `How to add ${app.name} to your website`;

  const subTitle = platform
    ? `Learn how to embed Common Ninja’s ${app.name} on your ${platform.title} ${platform.siteSynonym} without coding.`
    : `Learn how to embed Common Ninja’s ${app.name} on your website without coding.`;

  return (
    <StyledPlatofrmHero>
      <Header fixedPosition lightMode />
      <div className="navbar-wrapper">
        <WidgetNavbar
          widget={app}
          platform={platform}
          showLogo
          showTemplatesTab={showTemplatesTab}
        />
      </div>
      <div className="hero-wrapper">
        <div className="hero-text-wrapper">
          {platform && (
            <div className="hero-platform-logo">
              <Image src={platform.logo} alt={platform.title} fill />
            </div>
          )}
          <h1>{title}</h1>
          <h2>{subTitle}</h2>
          <div className="button-wrapper">
            <CustomLink
              variant="gradient"
              external
              title={`${app.buttonText} ${
                platform ? `for ${platform.title}` : ""
              }`}
              className="try-button"
              id="main-create-widget-cta"
              href={`/${app.slug}/editor`}
              onClick={createMobileAwareClickHandler(() => {
                // trackEvent(`Landing page ${widget.name}${platform ? ' ' + platform.title : ''}`, { serviceName: widget.serviceName });
              }, `/${app.slug}/editor`)}
            >
              {app.buttonText}
            </CustomLink>
            <SocialProof />
          </div>
        </div>
        <div className="hero-img-wrapper">
          <Image
            src="https://website-assets.commoninja.com/distribution/generic-bg.webp"
            alt="widget-editor"
            width={930}
            height={523}
            className="widget-editor-img"
          />
          <WidgetVideoGuideSSR
            widget={app}
            videoUrl={videoUrl || "https://www.youtube.com/watch?v=ZmB1KgLsGnw"} // default video for all widgets
            staticMode
          />
        </div>
      </div>
      <CommonNinjaWidgetRenderer
        widgetId={"87cf32fd-d8c2-4a3b-8cfc-0f419c000fbf"}
        style={{ filter: "brightness(0)" }}
      />
      <div className="in-this-guide-wrapper">
        <h2>In This Guide</h2>
        <p>
          In this quick guide, you&apos;ll learn how to embed the {app.name}{" "}
          into your {platform?.title || ""} {platform?.siteSynonym || "website"}{" "}
          by generating your embed code and adding it seamlessly to your{" "}
          {platform?.siteSynonym || "website"}.
        </p>
      </div>
    </StyledPlatofrmHero>
  );
};
